module.exports = __webpack_public_path__ + "img/60.3b0efecc.jpg";